const MaxNumberOfGuesses = () => {
    return 6;
}
export default MaxNumberOfGuesses;